import { createContext } from "react";

/**
 * @typedef {Object} GamStats
 * @property {number} impressionsDelivered
 * @property {number} clicksDelivered
 * @property {number} viewableImpressionsDelivered
 * @property {number} valueCostPerUnit
 * @property {number} costPerUnit
 * @property {"COMPLETED" | "READY" | "DELIVERING" | "PAUSED"} status
 */


/** @type {{geoTargetsInfo: {}, gamStats: Object.<string,GamStats>, individualStats: {}}} */
const gamData = {
    geoTargetsInfo: {},
    gamStats: {},
    individualStats: {},
}


export const MarketplaceGamDataContext = createContext(gamData)